/**
 * Entry point.
 *
 * Author: Danish Khan
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';
import { setupPwa } from './lib/pwa.ts';
import './styles/app.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');
// Before the first render: `beforeinstallprompt` can fire early, and an event nobody was
// listening for is an install affordance that never appears.
setupPwa();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
